<template>
	<div v-if="this.manufactor">
		<div style="background:var(--grey-4);padding:5px;margin-bottom:5px;border-radius: 5px;" :title="this.title"
			class="flexcenter link" @click="this.$emit('searchManufactorSelected', this.manufactor)">

			<div v-if="!this.productTypeSelected" class="badge" style="width:33px;text-align:center;margin-right:3px;font-size:80%;">{{
				this.productTypeLabel }}
			</div>

			<b>{{ this.manufactor.name }}</b>
			<b style="flex-grow:1;">&nbsp;</b>
			<div style="background:var(--grey-5);padding:3px;border-radius: 5px;">{{ this.productCount }}</div>
			<Icon fileName="w3_chevron_right_dark" style="height:15px;width:10px;margin-left:5px;" />
		</div>
	</div>
</template>
<script>
import { STORE_GETTER } from '@/store/store';
import { routerMixin } from "@/mixins/routerMixin.js";

//import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
//import { STORE_GETTER } from '@/store/store';

export default {
	name: "SearchManufactorRow",
	components: {},
	mixins: [routerMixin],
	props:{
		manufactorId: Number,
		productCount: String
	},
	data() {
		return {

		};
	},
	computed: {

		/*manufactor() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL];
			
			if (baseModel && baseModel.manufactorList) {
				return baseModel.manufactorList.find(manufactor =>  manufactor.manufactorId == this.manufactorId )
			}

			return null;
- PT :{{ this.manufactor.pt }} - ID: {{ this.manufactor?.manufactorId }}
		},*/

		title() {
			if (this.isOnProductListPage()) {
				return "Filtera resultatet på " + this.manufactor?.name;
			} else {
				return "Visa alla produkter från: " + this.manufactor?.name + ", antal: " + this.productCount
			}

		},

		manufactor() {
			const manufactorList = this.$store.getters[STORE_GETTER.MANUFACTOR_LIST];

			return manufactorList?.find(manufactor => manufactor.manufactorId == this.manufactorId)

		},


		productTypeModel() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL]
		},

		productTypeSelected() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED]

		},

		productTypeLabel() {
			const productType = this.productTypeModel?.list?.find(productType => productType.pt == this.manufactor.pt )
			if (productType){
				return productType.name
			}
			return null;
		},

		src(){
			return "https://public.boove.se/gfx/logos/" + this.manufactor.manufactorId + ".jpg"
		}

	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);

		// this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });


	},
	created() {

	}
};
</script>

<style scoped></style>